import { call, take, takeEvery, takeLatest, delay, put, race, select } from 'redux-saga/effects';

import { checkNetworkStatus } from '../../utils';
import { REFRESH_VALUES } from '../application';
import {
  START_NOTIFICATION_TIMER,
  CANCEL_NOTIFICATION_TIMER,
  START_POLLING_ONLINE,
  STOP_POLLING_ONLINE,
  CHECK_ONLINE,
  TYPES,
  setOnline,
  stopPollingOnline,
  setOffline,
  startPollingOnline,
  removeNotification,
  hideNotification,
} from './actions';
import { getOnline, getNotificationById } from './selectors';

let lastNetworkCheck = 0;

export function* delayedHideOrRemove(id, hideTimeout = 2000) {
  yield delay(hideTimeout);
  const notification = yield select(getNotificationById, id);
  if (notification && notification.type === TYPES.transient) {
    yield put(removeNotification(id));
  } else {
    yield put(hideNotification(id));
  }
}

export function* doStartNotificationTimer({ id }) {
  yield race([call(delayedHideOrRemove, id), take(CANCEL_NOTIFICATION_TIMER)]);
}

export function* pollReconnect() {
  while (true) {
    const online = yield call(checkNetworkStatus);
    if (online) {
      yield put(setOnline());
      yield put({ type: REFRESH_VALUES });
      yield put(stopPollingOnline());
    }
    yield delay(5000);
  }
}

export function* watchStartPollingOnline() {
  while (true) {
    yield take(START_POLLING_ONLINE);
    yield race([call(pollReconnect), take(STOP_POLLING_ONLINE)]);
  }
}

export function* checkOnline() {
  const isOnlineState = yield select(getOnline);
  if (isOnlineState && lastNetworkCheck + 5000 < Date.now()) {
    lastNetworkCheck = Date.now();
    const online = yield call(checkNetworkStatus);
    if (!online) {
      yield put(setOffline());
      yield put(startPollingOnline());
    }
  }
}

export const sagas = [
  call(watchStartPollingOnline),
  takeEvery(START_NOTIFICATION_TIMER, doStartNotificationTimer),
  takeLatest(CHECK_ONLINE, checkOnline),
];
